import { ModalController } from '@ionic/angular';
import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { WardrobeService } from './../../services/wardrobe.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';

@Component({
  selector: 'shc-create-brand-modal',
  templateUrl: './create-brand-modal.component.html',
  styleUrls: ['./create-brand-modal.component.scss'],
})
export class CreateBrandModalComponent implements OnInit {
  form: UntypedFormGroup;
  constructor(
    private wardrobeService: WardrobeService,
    private errorService: ErrorHandlerService,
    private modalCtrl: ModalController
  ) { }

  ngOnInit() {
    this.form = new UntypedFormGroup({
      name: new UntypedFormControl(null, [
        Validators.required
      ])
    });
  }

  onCreateBrand() {
    this.wardrobeService.createBranch(this.form.value).subscribe(res => {
      this.modalCtrl.dismiss(res, null, 'createBrandModal');
    }, error => {
      this.errorService.handle(error);
    });
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

}
